import { useCallback, useMemo, useSyncExternalStore } from 'react';

import {
  type AiFieldCellRequestState,
  type AiFieldCellRequestTarget
} from './ai-field-cell-request-coordinator.ts';
import { aiFieldCellRequestCoordinator } from './ai-field-cell-request-store.ts';

export const useAiFieldCellRequestState = (
  target: AiFieldCellRequestTarget
): AiFieldCellRequestState => {
  const { aiFieldType, contentId, entryId, fieldId, isTargetValueEmpty } = target;
  const requestTarget = useMemo(
    () => ({ aiFieldType, contentId, entryId, fieldId, isTargetValueEmpty }),
    [aiFieldType, contentId, entryId, fieldId, isTargetValueEmpty]
  );
  const subscribe = useCallback(
    (listener: () => void) =>
      aiFieldCellRequestCoordinator.subscribe(requestTarget, listener),
    [requestTarget]
  );
  const getSnapshot = useCallback(
    () => aiFieldCellRequestCoordinator.getRequestState(requestTarget),
    [requestTarget]
  );

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
